import { buildPermission } from "common/utils/auth";
import { getJobOrchestratePath, getJobPath } from "portal/utils/routing";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { ResponsiveSubnav } from "portal/components/ResponsiveSubnav";
import { titleCase } from "common/utils/strings";
import { useAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";
interface JobNavProps {
  jobId: string;
}
export const JobNav: FC<JobNavProps> = ({ jobId }) => {
  const { t } = useTranslation();
  const isInternalAuthorized = useAuthorizationRequired(
    buildPermission(
      PermissionAction.update,
      PermissionResource.autotractor_jobs,
      PermissionDomain.all
    )
  );
  return (
    <ResponsiveSubnav
      pages={[
        {
          label: titleCase(t("views.autotractor.jobDetails.jobDetails")),
          to: getJobPath(jobId),
        },
        {
          label: titleCase(t("views.autotractor.actions.internal")),
          to: getJobOrchestratePath(Number.parseInt(jobId)),
          hidden: !isInternalAuthorized,
        },
      ]}
    />
  );
};
